import { render, staticRenderFns } from "./NavLabels.vue?vue&type=template&id=36e0fa6c&scoped=true&"
import script from "./NavLabels.vue?vue&type=script&lang=js&"
export * from "./NavLabels.vue?vue&type=script&lang=js&"
import style0 from "./NavLabels.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NavLabels.vue?vue&type=style&index=1&id=36e0fa6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0fa6c",
  null
  
)

export default component.exports